import { render } from "./BoxPersons.vue?vue&type=template&id=ac4c6380"
import script from "./BoxPersons.vue?vue&type=script&setup=true&lang=js"
export * from "./BoxPersons.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Sources/JavaScript/Extensions/Lfmpublications/Vue/components/BoxPersons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ac4c6380"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ac4c6380', __exports__)) {
    api.reload('ac4c6380', __exports__)
  }
  
  module.hot.accept("./BoxPersons.vue?vue&type=template&id=ac4c6380", () => {
    api.rerender('ac4c6380', render)
  })

}


export default __exports__